import queryString from "query-string";
import React from "react";
import { useLocation, useNavigate } from "react-router";
import { getSettings } from "src/services/configService";

/**
 * The devices page's "Add device" action: the enrollment page where the tenant has one, otherwise `AddDeviceModal`.
 * Render the modal once with `modalProps`, so every button that adds a device opens the same one.
 * `?openEnrollmentModal=true` in the URL opens the modal on arrival.
 */
export const useAddDevice = () => {
    const [modalChoice, setModalChoice] = React.useState<boolean | null>(null);
    const location = useLocation();
    const navigate = useNavigate();
    const { features } = getSettings();

    const searchParams = queryString.parse(location.search);
    const open = modalChoice ?? searchParams.openEnrollmentModal === "true";

    const addDevice = () => {
        if (features.enrollmentFlowEnabled) {
            navigate("/dashboard/enrollment");
            return;
        }
        setModalChoice(true);
    };

    const onClose = () => {
        setModalChoice(false);
        if (searchParams.openEnrollmentModal !== undefined) {
            const newSearch = queryString.stringify(
                { ...searchParams, openEnrollmentModal: undefined },
                { skipEmptyString: true, skipNull: true },
            );
            void navigate({ search: newSearch }, { replace: true });
        }
    };

    return { addDevice, modalProps: { open, onClose } };
};
